import styled from 'styled-components';

// import {Link } from 'react-scroll'

export const BtnUp = styled.button`
  position: fixed;
  z-index: 10;
  bottom: clamp(18px, 3vw, 30px);
  right: clamp(18px, 3vw, 30px);
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  padding: 0;
  font-size: 20px;
  color: #fff;
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    background 0.2s ease;
  background: linear-gradient(145deg, #ff7a18, #d65700);
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 50%;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.28);
  cursor: pointer;

  &:hover {
    background: linear-gradient(145deg, #ff8b35, #e8670a);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 3px solid rgba(255, 122, 24, 0.4);
    outline-offset: 3px;
  }
`;
